module.exports = {
      id: "plan-selected-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "images/js_src_vue/page_adguard_landing/sprite.dab809d9.svg#plan-selected-usage",
      toString: function () {
        return this.url;
      }
    }